import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WilderWidget from "@/components/WilderWidget";
import Home from "@/pages/Home";
import Galleria from "@/pages/Galleria";
import AssaggiArte from "@/pages/AssaggiArte";
import WilderPage from "@/pages/WilderPage";
import Corsi from "@/pages/Corsi";
import Servizi from "@/pages/Servizi";
import Blog, { BlogPost } from "@/pages/Blog";
import Ricette from "@/pages/Ricette";
import Shop from "@/pages/Shop";
import Academy from "@/pages/Academy";
import AssaggiSalento from "@/pages/AssaggiSalento";
import ChiSiamo from "@/pages/ChiSiamo";
import Contatti from "@/pages/Contatti";
import PaymentResult from "@/pages/PaymentResult";
import Admin from "@/pages/Admin";
import OptinGuida from "@/pages/OptinGuida";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.pointerEvents = "";
    document.body.style.overflow = "";
  }, [pathname]);
  return null;
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch() {}
  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.pathname !== this.props.pathname) {
      this.setState({ hasError: false });
    }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-5" data-testid="error-fallback">
          <p className="font-display text-3xl font-bold mb-3">Ops, qualcosa si è inceppato.</p>
          <p className="text-sm text-[#C9C4B8] mb-6">Nessun problema: torna alla home e riprova.</p>
          <a href="/" className="btn-primary">Torna alla Home</a>
        </div>
      );
    }
    return this.props.children;
  }
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin") || pathname.startsWith("/guida-");
  return (
    <div className="ws-grain min-h-screen flex flex-col">
      <ScrollToTop />
      {!isAdmin && <Header />}
      <main className="flex-1">
        <ErrorBoundary pathname={pathname}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/galleria" element={<Galleria />} />
          <Route path="/assaggi-darte" element={<AssaggiArte />} />
          <Route path="/assaggi-arte-salento" element={<AssaggiSalento />} />
          <Route path="/wilder" element={<WilderPage />} />
          <Route path="/corsi" element={<Corsi />} />
          <Route path="/ricette" element={<Ricette />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/academy" element={<Academy />} />
          <Route path="/servizi" element={<Servizi />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/pagamento/successo" element={<PaymentResult />} />
          <Route path="/pagamento/annullato" element={<PaymentResult cancelled />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/login" element={<Navigate to="/admin" replace />} />
          <Route path="/guida-assaggi-arte" element={<OptinGuida variant="assaggi" />} />
          <Route path="/guida-wild-chef-jr" element={<OptinGuida variant="jr" />} />
          <Route path="*" element={
            <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-5" data-testid="not-found-page">
              <p className="font-display text-3xl font-bold mb-3">Pagina non trovata</p>
              <p className="text-sm text-[#C9C4B8] mb-6">Il link potrebbe essere cambiato o non ancora pubblicato.</p>
              <a href="/" className="btn-primary">Torna alla Home</a>
            </div>
          } />
        </Routes>
        </ErrorBoundary>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && pathname !== "/wilder" && <WilderWidget />}
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}
